
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexaG8vLvR4DyCdgBC2swVGcrTcPLVyH3vrnAMTwKgvFN8Meta } from "/home/devtea/_repos/cipondo-powerindo/pages/index.vue?macro=true";
import { default as historykZBwKUeHmJ5lvQC3E4dZdnJ5w97HJOAN0hsRJs8FuDkMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/history.vue?macro=true";
import { default as indexY1dcKDpV8qQ_45eti9QorfgaNNBqwzLEIn3O9gvfyT5vAMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/rent/index.vue?macro=true";
import { default as print0dIP2jhQOOzlDWRO33Sl3u98o5peEGDqCKeXk_45sTfL0Meta } from "/home/devtea/_repos/cipondo-powerindo/pages/rent/print.vue?macro=true";
import { default as _91id_937Cp5Knb5gg104Bq7nR6_45MaFZrCQbZByFVKzN7Vq56AQMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/copotan/[id].vue?macro=true";
import { default as index5XD6c4YE2tdA7R7AbNNtuyMh9iNX0VCKXpHCXeC2vYkMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/copotan/index.vue?macro=true";
import { default as _91id_93q6k2H_452W5yL740iETnkIH5jR_45c_rYGwlspeJl1za4BAMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/sparepart/[id].vue?macro=true";
import { default as merkk5WrbjUWF_JDn3xN7I_geax4MziCQmdd9H5a8V2d2WYMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/merk.vue?macro=true";
import { default as index7awPnmC175KFRNsvEeBS3aIxciRCxpvJJ0ZnQ0TomDYMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/sparepart/index.vue?macro=true";
import { default as jenisoHosJ_Z_45k4zLb7hr5PsLFke08zNBsZHepSJgaHm9P0sMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/sparepart/jenis.vue?macro=true";
import { default as index_45Zfng_MlaWw5moz8l6w8HVzOspUh_ZYhl4hTICNs2P0Meta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/index.vue?macro=true";
import { default as jenist5SuumuQCt2blUNDhmdSuU3kWIXvaIw74INXYqkn54gMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/jenis.vue?macro=true";
import { default as modeliv3C152s9oGa_45b0SwM8XNzR07S0kWqeUdJcNLi_BHTAMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/model.vue?macro=true";
import { default as printoPNk41vGL9FcAHJjbcNmVtDwg_HNdM0S1v9gJkOs598Meta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/print.vue?macro=true";
import { default as lokasilbSnTIaHsVO2XBUgC_45RUt9XK6nzG2PHHBczgbvkGeV4Meta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/lokasi.vue?macro=true";
import { default as _91id_93C78ZcAkRcppWkWPeBaSsQBUc_45XqH2PVvimZmYt5sCqgMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/sparepart/buy/[id].vue?macro=true";
import { default as printx2f4cD0AcRqzL1MMJp_8N9VsxMX1IOYUzqRXO69xugIMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/sparepart/buy/print.vue?macro=true";
import { default as indexpMS79mWdygiC75C2ubcBx51zwblImzXMgOGGtkjNSHUMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/[id]/index.vue?macro=true";
import { default as indexHkvuEpspxTsfF_45gectIfi4LgcLeLAH7f5xk7PXL7UUIMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/sold/index.vue?macro=true";
import { default as printiAdmlOFgJDSecePYeDxNqYPEY_45o04_Bs7PzXIYErcx8Meta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/sold/print.vue?macro=true";
import { default as indexWv9lxFq3N1hI62fu6xJY64CBLsPFD_457vsD6hvzqEydsMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/buy/[id]/index.vue?macro=true";
import { default as _91sellId_932UJ2edPtzpQZypH2tGqUM871oxA5pP3RVOE_456zHvTtIMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/[id]/sell/[sellId].vue?macro=true";
import { default as index7DJMLrmFC3TTKk_kvRTjE9iE6muk1A2DkGyWYJgCzhUMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/[id]/list-biaya/index.vue?macro=true";
import { default as printXuN5hwZSQWtEG3EAyQ7YCgln2s6HpjF95wqQj4AYCOoMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/[id]/list-biaya/print.vue?macro=true";
import { default as _91id_93bkigkBxqlHP_RDfDp1C0E29iIFnQO_45KE90yo0atmbtoMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/add-[biayaType]-[alatBeratId]/[id].vue?macro=true";
import { default as _91id_93g0Jymc0n1oNMz3tTDiSts32eTrKh0NjpBw1nfN1IfKQMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/sparepart/pengiriman-[buySparepartId]/[id].vue?macro=true";
import { default as indexbKK0MUz39xAku_uCTf4Ym2eCzdvdBdPf_455VOH2pQEGgMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/[id]/rent/[rentId]/[rentTransactionsId]/index.vue?macro=true";
import { default as printPrdPQ0ZAbrX4x4f1n9OYvnAL_241kUnH7HinqFK283gMeta } from "/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/[id]/rent/[rentId]/[rentTransactionsId]/print.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/index.vue")
  },
  {
    name: "history",
    path: "/history",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/history.vue")
  },
  {
    name: "rent",
    path: "/rent",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/rent/index.vue")
  },
  {
    name: "rent-print",
    path: "/rent/print",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/rent/print.vue")
  },
  {
    name: "copotan-id",
    path: "/copotan/:id()",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/copotan/[id].vue")
  },
  {
    name: "copotan",
    path: "/copotan",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/copotan/index.vue")
  },
  {
    name: "stock-sparepart-id",
    path: "/stock/sparepart/:id()",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/sparepart/[id].vue")
  },
  {
    name: "stock-alat-berat-merk",
    path: "/stock/alat-berat/merk",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/merk.vue")
  },
  {
    name: "stock-sparepart",
    path: "/stock/sparepart",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/sparepart/index.vue")
  },
  {
    name: "stock-sparepart-jenis",
    path: "/stock/sparepart/jenis",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/sparepart/jenis.vue")
  },
  {
    name: "stock-alat-berat",
    path: "/stock/alat-berat",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/index.vue")
  },
  {
    name: "stock-alat-berat-jenis",
    path: "/stock/alat-berat/jenis",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/jenis.vue")
  },
  {
    name: "stock-alat-berat-model",
    path: "/stock/alat-berat/model",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/model.vue")
  },
  {
    name: "stock-alat-berat-print",
    path: "/stock/alat-berat/print",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/print.vue")
  },
  {
    name: "stock-alat-berat-lokasi",
    path: "/stock/alat-berat/lokasi",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/lokasi.vue")
  },
  {
    name: "stock-sparepart-buy-id",
    path: "/stock/sparepart/buy/:id()",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/sparepart/buy/[id].vue")
  },
  {
    name: "stock-sparepart-buy-print",
    path: "/stock/sparepart/buy/print",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/sparepart/buy/print.vue")
  },
  {
    name: "stock-alat-berat-id",
    path: "/stock/alat-berat/:id()",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/[id]/index.vue")
  },
  {
    name: "stock-alat-berat-sold",
    path: "/stock/alat-berat/sold",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/sold/index.vue")
  },
  {
    name: "stock-alat-berat-sold-print",
    path: "/stock/alat-berat/sold/print",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/sold/print.vue")
  },
  {
    name: "stock-alat-berat-buy-id",
    path: "/stock/alat-berat/buy/:id()",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/buy/[id]/index.vue")
  },
  {
    name: "stock-alat-berat-id-sell-sellId",
    path: "/stock/alat-berat/:id()/sell/:sellId()",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/[id]/sell/[sellId].vue")
  },
  {
    name: "stock-alat-berat-id-list-biaya",
    path: "/stock/alat-berat/:id()/list-biaya",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/[id]/list-biaya/index.vue")
  },
  {
    name: "stock-alat-berat-id-list-biaya-print",
    path: "/stock/alat-berat/:id()/list-biaya/print",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/[id]/list-biaya/print.vue")
  },
  {
    name: "stock-add-biayaType-alatBeratId-id",
    path: "/stock/add-:biayaType()-:alatBeratId()/:id()",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/add-[biayaType]-[alatBeratId]/[id].vue")
  },
  {
    name: "stock-sparepart-pengiriman-buySparepartId-id",
    path: "/stock/sparepart/pengiriman-:buySparepartId()/:id()",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/sparepart/pengiriman-[buySparepartId]/[id].vue")
  },
  {
    name: "stock-alat-berat-id-rent-rentId-rentTransactionsId",
    path: "/stock/alat-berat/:id()/rent/:rentId()/:rentTransactionsId()",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/[id]/rent/[rentId]/[rentTransactionsId]/index.vue")
  },
  {
    name: "stock-alat-berat-id-rent-rentId-rentTransactionsId-print",
    path: "/stock/alat-berat/:id()/rent/:rentId()/:rentTransactionsId()/print",
    component: () => import("/home/devtea/_repos/cipondo-powerindo/pages/stock/alat-berat/[id]/rent/[rentId]/[rentTransactionsId]/print.vue")
  }
]